import React from 'react';
import { BaseStatusCode } from "./BaseStatusCode.js";
import { Illustration403 } from "./illustrations/Illustration403.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusCode403 = ({
  className,
  title,
  description,
  component
}) => {
  return /*#__PURE__*/_jsx(BaseStatusCode, {
    className: className,
    illustration: /*#__PURE__*/_jsx(Illustration403, {}),
    title: title ?? 'Sie haben leider keine Berechtigung diese Seite zu sehen.',
    description: description,
    component: component
  });
};